import { render, staticRenderFns } from "./SalvarNaColecao.vue?vue&type=template&id=590d5328&scoped=true&"
import script from "./SalvarNaColecao.vue?vue&type=script&lang=js&"
export * from "./SalvarNaColecao.vue?vue&type=script&lang=js&"
import style0 from "./SalvarNaColecao.vue?vue&type=style&index=0&id=590d5328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d5328",
  null
  
)

export default component.exports